/**
 * MeasurementsFilters - Client selection component
 * Controlled component for filtering measurements by client
 */

import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "@/hooks/useTranslation";
import type { Klient } from "../types";
import { getClientDisplayName } from "../utils";

interface MeasurementsFiltersProps {
  selectedKlientId: number | null;
  onKlientChange: (klientId: number | null) => void;
  klienti: Klient[];
}

export function MeasurementsFilters({
  selectedKlientId,
  onKlientChange,
  klienti,
}: MeasurementsFiltersProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <Label>{t("measurements:selectClient")}</Label>
      <Select
        value={selectedKlientId?.toString() || ""}
        onValueChange={value => onKlientChange(Number(value))}
      >
        <SelectTrigger className="max-w-md">
          <SelectValue placeholder={t("measurements:chooseClient")} />
        </SelectTrigger>
        <SelectContent>
          {klienti.map(k => (
            <SelectItem key={k.id} value={k.id.toString()}>
              {getClientDisplayName(k)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
